import React from 'react'
import { useTranslation } from 'react-i18next';
import { subMenuHome, subMenuPartners, subMenuProjects } from '../../../assets/images';


  const newsItems = [
    {
      id: 1,
      imgSrc: subMenuHome,
      title: 'İsitmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 2,
      imgSrc: subMenuPartners,
      title: 'Ventilyasiya',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 3,
      imgSrc: subMenuProjects,
      title: 'Soyutma, kondisionerləşdirmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
        id: 4,
        imgSrc: subMenuHome,
        title: 'Santexnika',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 5,
        imgSrc: subMenuPartners,
        title: 'Yanğınsöndürmə',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 6,
        imgSrc: subMenuProjects,
        title: 'Elektrik sistemləri',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 7,
        imgSrc: subMenuHome,
        title: 'Aşağı cərəyan',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 8,
        imgSrc: subMenuPartners,
        title: 'Avtomatlaşdırma sistemləri',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 9,
        imgSrc: subMenuProjects,
        title: 'Kanal sexi',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
  ];

const CareersLifeItems = () => {


      const { t } = useTranslation();

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
        <div className='max-w-containerSm md:max-w-container mx-auto gap-5'>
        <div className=' text-[#1C1C1C]'>
 <img className='w-full' src={subMenuPartners}></img>
    <p className='mt-10'>Şirkətimizdə komanda ruhu çox vacibdir. Biz dəstək göstərməyə açıq, birlikdə işləməkdən zövq alan və hədəflərə birlikdə çatmağa yönəlmiş bir iş mühiti yaratmağa çalışırıq. Biz müxtəlif tədbirlər, komanda qurma oyunları keçirməklə, özəl günləri qeyd etməklə korporativ ruhumuzu daha da gücləndiririk.</p>
    
        </div>


    </div>
    </div>
  )
}

export default CareersLifeItems